export default {
  en: {
    date: {
      year: 'numeric', month: '2-digit', day: '2-digit'
    },
    datetime: {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: 'numeric', minute: 'numeric', second: 'numeric'
    }
  },
  pt: {
    date: {
      year: 'numeric', month: '2-digit', day: '2-digit'
    },
    datetime: {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: 'numeric', minute: 'numeric', second: 'numeric'
    }
  },
  es: {
    date: {
      year: 'numeric', month: '2-digit', day: '2-digit'
    },
    datetime: {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: 'numeric', minute: 'numeric', second: 'numeric'
    }
  },
};